import { Container, Grid, Box, Link, Typography } from '@mui/material';
import { ProfileAvatar } from '@care/react-component-lib';
import { formatStartDate } from '@/utils/formatStartDate';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { getSegmentationJobDetails_getSEOSegmentationJobDetails_nearbyJobs as NearbyJob } from '@/__generated__/getSegmentationJobDetails';
import { OtherJobItem } from './OtherJobItem';

interface NearbyJobsProps {
  jobs: NearbyJob[];
}

const NearbyJobs = ({ jobs }: NearbyJobsProps) => {
  const nearbyJobTrack = () => {
    const amplitudeData = { cta_location: 'bottom', cta_text: 'view similar jobs' };

    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, amplitudeData);
  };
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box mb={{ xs: 1, sm: 2 }}>
        <Typography variant="h2">Similar jobs nearby</Typography>
      </Box>
      <Grid container key="nearbyJobs">
        {jobs.map((job: NearbyJob) => {
          return (
            <Grid item md={5} xs={12} key={job.job.title}>
              <Grid container mt={1} sx={{ cursor: 'pointer' }}>
                <Link
                  href={job.url || ''}
                  onClick={nearbyJobTrack}
                  underline="none"
                  sx={(theme) => ({
                    color: theme.palette.text.primary,
                    '&:hover': { color: theme.palette.text.primary },
                  })}>
                  <Box display="flex" mt={1}>
                    <Box>
                      <ProfileAvatar
                        alt="profile"
                        src={job.seekerAvatar ?? undefined}
                        size="xLarge">
                        <Box
                          height="100%"
                          justifyContent="center"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          textAlign="center">
                          <Typography variant="h5" component="div" width="100%">
                            {formatStartDate(job.job.startDate).month.toLocaleUpperCase()}
                          </Typography>
                          <Typography variant="h2" component="div" width="100%">
                            {formatStartDate(job.job.startDate).day.toUpperCase()}
                          </Typography>
                        </Box>
                      </ProfileAvatar>
                    </Box>
                    <Box ml={2} maxWidth="240px">
                      <Typography variant="h4">{job.job.title}</Typography>
                      <Box>
                        <Typography variant="info1" color="secondary">
                          {job.city}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Link>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Box mt={4} key="otherJobs">
        <Box mb={2}>
          <Typography variant="h4">Or take a look at some other job options:</Typography>
        </Box>
        <Box maxWidth="75%">
          <Box>
            <OtherJobItem href="/babysitting-jobs" title="Babysitting Jobs" />
            <OtherJobItem href="/nanny-jobs" title="Nanny Jobs" />
            <OtherJobItem href="/tutoring-jobs" title="Tutoring Jobs" />
            <OtherJobItem href="/housekeeping-jobs" title="Housekeeping Jobs" />
          </Box>
          <Box>
            <OtherJobItem href="/pet-care-jobs" title="Pet Care Jobs" />
            <OtherJobItem href="/senior-care-jobs" title="Senior Care Jobs" />
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default NearbyJobs;
